import { render, staticRenderFns } from "./ManageTodo.vue?vue&type=template&id=01c2675c&scoped=true&"
import script from "./ManageTodo.vue?vue&type=script&lang=js&"
export * from "./ManageTodo.vue?vue&type=script&lang=js&"
import style0 from "./ManageTodo.vue?vue&type=style&index=0&id=01c2675c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2675c",
  null
  
)

export default component.exports